import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	hideFromSidebar: {
		id: 'navigation.global-side-navigation.more-menu.hide-from-sidebar.label',
		description:
			'Label on Hide from sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
		defaultMessage: 'Hide from sidebar',
	},
});
